// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar__column{flex-basis:0;flex-grow:1;max-width:100%;min-width:0}@media screen and (max-width:1349px){.sidebar__swiper-container{display:block}.sidebar__column{display:none}}@media screen and (min-width:1350px){.sidebar__swiper-container{display:none}.sidebar__column{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
